import React from 'react';
import { Col, Form, Row } from 'antd';
import Title from 'components/Title';
import { Pie } from '@ant-design/charts';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { toCurrency } from 'utils/utils';

const NEW_ACTION_ID = -1;

export type UsageTabProps = {
  offerPricing: any;
};

const UsageTab = ({ offerPricing }: UsageTabProps) => {
  const [form] = Form.useForm();
  const fieldName = 'vendors';

  let data = [
    {
      type: 'Booked',
      value: offerPricing?.attbudgetbooked,
    },
    {
      type: 'Used',
      value: offerPricing?.attbudgetused,
    },
    {
      type: 'Available',
      value:
        offerPricing?.attbudget -
        offerPricing?.attbudgetbooked -
        offerPricing?.attbudgetused,
    },
  ];

  const columns: DataGridColDef<any>[] = [
    {
      dataIndex: 'propreference',
      width: 130,
    },

    {
      dataIndex: 'attamount',
      render: (val) => toCurrency(val, localStorage.getItem('currcode') ?? ''),
      width: 100,
    },
    {
      dataIndex: 'ctphase',
      width: 130,
    },
    {
      dataIndex: 'attstatus',
      width: 130,
    },
  ];

  const config = {
    appendPadding: 10,
    data,
    angleField: 'value',
    colorField: 'type',
    radius: 0.9,
    label: {
      type: 'inner',
      offset: '-30%',
      style: {
        fontSize: 14,
        textAlign: 'center',
      },
    },
    interactions: [
      {
        type: 'element-active',
      },
    ],
  };

  return (
    <Row>
      <Col span={24}>
        <div style={{ textAlign: 'center' }}>
          <Title level={2} comcode="offerpricingattribute" />
        </div>
      </Col>
      <Col span={12}>
        <DataGrid
          titleComcode="useDetail"
          columns={columns}
          dataSource={offerPricing?.useDetail}
          size="small"
          hideExtraAction
          hideFilters
        />
      </Col>

      <Col span={12}>{offerPricing && <Pie {...config} />}</Col>
    </Row>
  );
};

export default UsageTab;
